module.exports = __webpack_public_path__ + "img/score-icon-5.dd1bc717.png";